import SessionEventProto from "../session-event-proto"
import WebhooksCollection from "../../model2/webhook/webhook-v2/collection"

/**
 * The company's whole webhook list, pushed by the server after any change to
 * it. There is no new/delta/delete — see the backend's
 * EventWebhooksCompanyReset for why a reset is the only method.
 *
 * It is applied even when nothing ever asked for webhooks: the payload is
 * exactly what a load would have fetched, so accepting it just means the next
 * reader is served from the session.
 */
export default class SessionEvent_WebhookReset extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {

        if (this.isDifferentCompany()) return

        gd.session.setWebhooks(WebhooksCollection.initFromJson(this.data))
    }
}
